export const event = {
  eventLogo: 'https://cdn.magicpatterns.com/uploads/wkApFctTadTHV7J6KFurW4/Logo_Light_background_copy.jpg',
  organizerLogo: 'https://cdn.magicpatterns.com/uploads/rxnFGMHjpCg2yfoTHsqiWe/Logo_Confederation_nationale_du_tourisme_Maroc_depuis_2022.jpg',
  formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfpkNyxQy2Fk56WErgl9sEY6oEdfwMUzCvSLX5fUfbiWww1bQ/viewform',
  liveUrl: 'https://www.youtube.com/watch?v=VBFmIhbQztw',
  liveStart: '2026-09-28T15:00:00+01:00',
  liveAvailability: 'Disponible lundi 28 Sept à 15h00'
};
